import { capitalize, isEmpty, toLower } from 'lodash';

export const getEventDepartments = (items) => {
  const allDepartments = items.reduce((acc, item) => {
    if (item.eventSectors.length > 1) item.eventSectors.forEach((type) => acc.push(type));
    if (item.eventSectors.length === 1) acc.push(item.eventSectors[0]);
    return acc;
  }, []);

  allDepartments.sort();

  const uniqueDepartments = ['Industry', ...new Set(allDepartments)];
  return uniqueDepartments;
};

export const getInsightsIndustries = (items) => {
  const allIndustries = items.reduce((acc, item) => {
    if (!isEmpty(item.industries)) {
      if (item.industries.length === 1) acc.push(toLower(item.industries[0]));
      if (item.industries.length > 1)
        item.industries.forEach((industry) => acc.push(toLower(industry)));
    }
    return acc;
  }, []);

  allIndustries.sort();

  const uniqueIndustries = [
    'By Industry',
    ...new Set(allIndustries.map((value) => capitalize(value))),
  ];
  return uniqueIndustries;
};

export const getEventTypes = (items) => {
  const allTypes = items.reduce((acc, item) => {
    if (item.eventType.length) item.eventType.forEach((type) => acc.push(type));
    if (item.eventType.length === 1) acc.push(item.eventType[0]);
    return acc;
  }, []);

  const moddedArr = allTypes.reduce((acc, type) => {
    if (type.includes(', ')) type.split(', ').forEach((value) => acc.push(value));
    else acc.push(type);
    return acc;
  }, []);

  moddedArr.sort();

  const uniqueTypes = ['Event Type', ...new Set(moddedArr)];

  return uniqueTypes;
};

export const convertHtmlIntoArray = (htmlContent) => {
  const alphaNumRegEx = /[a-zA-Z0-9\u0600-\u06FF]/gi;
  const div = document.createElement('div');

  div.innerHTML = htmlContent;

  const contentArr = [];

  div.childNodes.forEach((node) => contentArr.push(node.outerHTML));

  return contentArr.filter((value) => alphaNumRegEx.test(value));
};
